import React from "react";
import {Button, Form, FormGroup, FormControl, ControlLabel, Modal} from "react-bootstrap";
import Request from "request";

class TicketCreator extends React.Component {
	state = {
		count: 1,
	};

	constructor(props, context) {
		super(props, context);

		this.handleCreate = this.handleCreate.bind(this);
		this.handleChangeCount = this.handleChangeCount.bind(this);
	}

	handleCreate() {
		const {count} = this.state;
		const {event, onCreate} = this.props;

		Request.post(`/api/cp/event/${event.eventPassword}/ticket`, {count})
			.then(onCreate);
	}

	handleChangeCount(count) {
		const max = this.props;
		if(isNaN(count)) {
			count = 1;
		} else if(count > max) {
			count = max;
		} else if(count <= 0) {
			count = 1;
		}
		this.setState({count});
	}

	render() {
		const {show, onHide, max: maxTickets, event} = this.props;
		const {count} = this.state;

		return (
			<Modal show={show} onHide={onHide} bsSize="large">
				<Modal.Header closeButton>
					<Modal.Title>Добавление билетов</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form>
						<FormGroup>
							<ControlLabel>Укажите количество билетов</ControlLabel>
							<FormControl type="number" value={count} min={1} max={maxTickets}
										 onChange={e => this.handleChangeCount(parseInt(e.target.value))}/>
						</FormGroup>
					</Form>
				</Modal.Body>
				<Modal.Footer>
					<span style={{marginRight: 40}}>Осталось {maxTickets} билетов из {event.moduleMain.ticketLimit}</span>
					<Button bsStyle="primary" onClick={this.handleCreate}>Создать</Button>
					<Button onClick={onHide}>Закрыть</Button>
				</Modal.Footer>
			</Modal>
		)
	}
}

export default TicketCreator;
